import { getValidationMessage } from "../../utils/i18nHelper";
import { validationMessages } from "./userDataFormOpt";


export const getCompanyNameValidators = (lang) => {
    let companyNameValidators = {
        validators: {
            notEmpty: {
                message: getValidationMessage(validationMessages, 'companyName', 'required', lang)
            },
        }
    };
    return companyNameValidators;
};

export const getCeoFirstNameValidators = (lang) => {
    let ceoFirstNameValidators = {
        validators: {
            notEmpty: {
                message: getValidationMessage(validationMessages, 'ceoFirstName', 'required', lang)
            },
        }
    };
    return ceoFirstNameValidators;
};

export const getCeoLastNameValidators = (lang) => { 
    let ceoLastNameValidators = {
        validators: {
            notEmpty: {
                message: getValidationMessage(validationMessages, 'ceoLastName', 'required', lang)
            },
        }
    };
    return ceoLastNameValidators;
};

export const getBusinessStreetValidators = (lang) => {
    let businessStreetValidators = {
        validators: {
            notEmpty: {
                message: getValidationMessage(validationMessages, 'businessStreet', 'required', lang)
            },
        }
    };
    return businessStreetValidators;
};

export const getBusinessZipValidators = (lang) => {
    let businessZipValidators = {
        validators: {
            notEmpty: {
                message: getValidationMessage(validationMessages, 'businessZip', 'required', lang)
            },
        }
    };
    return businessZipValidators;
};

export const getBusinessCityValidators = (lang) => {
    let businessCityValidators = {
        validators: {
            notEmpty: {
                message: getValidationMessage(validationMessages, 'businessCity', 'required', lang)
            },
        }
    };
    return businessCityValidators;
};

export const getBusinessCountryValidators = (lang) => {
    let businessCountryValidators = {
        validators: {
            notEmpty: {
                message: getValidationMessage(validationMessages, 'businessCountry', 'required', lang)
            },
        }
    };
    return businessCountryValidators;
};

export const getTradeRegistryExportValidators = (lang) => {
    let tradeRegistryExportValidators = {
        validators: {
            notEmpty: {
                message: ''
            },
            file: {
                extension: 'pdf',
                type: 'application/pdf',
                maxSize: 5 * 1024 * 1024, // 5 MB
                message: getValidationMessage(validationMessages, 'tradeRegistryExport', 'file', lang)
            }
        }
    };
    return tradeRegistryExportValidators;
};

export const getTradeRegistryExportURLValidators = (lang) => {
    let tradeRegistryExportURLValidators = {
        validators: {
            notEmpty: {
                message: getValidationMessage(validationMessages, 'tradeRegistryExportURL', 'required', lang)
            },
        }
    };
    return tradeRegistryExportURLValidators;
};

export  const getTradeRegistryCompanyUrlValidators = (lang) => {
    let tradeRegistryCompanyUrlValidators = {
        validators: {
            notEmpty: {
                message: getValidationMessage(validationMessages, 'tradeRegistryCompanyUrl', 'required', lang)
            },
        }
    };
    return tradeRegistryCompanyUrlValidators;
};
